import { Module } from 'vuex';

interface ProgressState {
  progress: number;
  blinking: boolean; // 깜빡임 상태를 관리하는 변수
}

const progressModule: Module<ProgressState, any> = {
  namespaced: true,
  state: {
    progress: 0,
    blinking: false,
  },
  mutations: {
    setProgress(state, progress: number) {
      state.progress = progress;
    },
    resetProgress(state) {
      state.progress = 0;
    },
    setBlinking(state, blinking: boolean) {
      state.blinking = blinking;
    },
    resetBlinking(state) {
      state.blinking = false;
    },
  },
};

export default progressModule;
